import React from "react";
import styles from "./WizardHeader.module.scss";
import SVG from "react-inlinesvg";
import {ReactComponent as CloseXIcon} from "ui-components-rollup/src/images/monochrome-icons/ic-close.svg";
import { StyledLink } from "../..";

const WizardHeader = ({logo, Icon, label, children, onClose, closeLink}) => {
    return <header className={styles.base}>
        <div className={styles.label}>
            {logo && <SVG src={logo}/>}
            {Icon && <Icon/>}
            <span>{label}</span>
        </div>
        {children}
        {onClose && <button type="button" onClick={onClose} className={styles.close}><CloseXIcon/></button>}
        {closeLink && <StyledLink type="text" color="secondary" className={styles.close} to={closeLink}><CloseXIcon/></StyledLink>}
    </header>
}

export default WizardHeader;
